import { Claim } from '@1po/1po-bff-fe-spec/generated/claim/response/model/Claim';
import { textFormatter } from 'utils';
import { isValidDate } from 'utils/format/formattingService';
import { ALL_DRAWER, ATTACHMENT, COMMENT, TimelineItem, TimelineType } from './ClaimDrawer.types';

export const formatDateTime = (dateTime: string | undefined): string => {
  if (!dateTime) return '';
  return isValidDate(dateTime) ? textFormatter.formatTime(new Date(dateTime)) : dateTime;
};

export const buildTimelineItems = (claim: Claim | null, timelineType: TimelineType): TimelineItem[] => {
  if (!claim) return [];

  const items: TimelineItem[] = [];

  if (timelineType === ALL_DRAWER && claim.supplierComments) {
    for (const comment of claim.supplierComments) {
      items.push({
        type: COMMENT,
        date: comment.commentCreationDateTime,
        data: comment,
      });
    }
  }

  if (claim.supplierAttachmentsMessages) {
    for (const supplierAttachmentMessage of claim.supplierAttachmentsMessages) {
      items.push({
        type: ATTACHMENT,
        date: supplierAttachmentMessage.attachmentsCreationDateTime,
        data: supplierAttachmentMessage,
      });
    }
  }

  items.sort((a, b) => {
    const dateA = a.date ? new Date(a.date).getTime() : 0;
    const dateB = b.date ? new Date(b.date).getTime() : 0;
    return dateB - dateA;
  });

  return items;
};
